const obj = {
  title: "WHY VISION?".toUpperCase(),
  text1: {
    regular:
      "Vision is the community’s answer to the growing challenges we face today. It’s the solution to avoid".toUpperCase(),
    bold: "the bans, wipes, and pressures that have been placed on us.".toUpperCase(),
  },
  text2: {
    regular:
      "How can they wipe us when we’re actively updating and securing links to chats every day across all platforms?".toUpperCase(),
    bold: "It's impossible.".toUpperCase(),
  },
  text3: "Vision is also the way to protect the community from low-quality, poor projects.".toUpperCase(),
  text4:
    "Have you noticed how all these money-making chats have turned into shit for dating or even talking about weed?".toUpperCase(),
  text5:
    "And don’t get me started on the botted chats and forums - it`s undermining trust in the community and damaging the credibility of the real veterans.".toUpperCase(),
  text6:
    "At Vision, we’re gathering both: the essentials and fresh-blood projects with a big future ahead.".toUpperCase(),
  text7: "We believe in strengthening the network, creating deeper roots, and fostering real business.".toUpperCase(),
  we_are_the: "WE ARE THE".toUpperCase(),
  text8:
    "Our mission is to make our community stronger and richer than ever before. The whole network will be united by a common business foundation.".toUpperCase(),
  text9:
    "We’re open to collaborating with anyone who has a strong reputation and a worthwhile offer to cooperate.".toUpperCase(),
}

const formatted = obj
export default formatted
